import { Injectable, signal } from '@angular/core';

export interface TourStep {
  elementId: string;
  /** Optional exact CSS selector for a dedicated highlight target. */
  targetSelector?: string;
  titleKey: string;
  descriptionKey: string;
}

/** Drives a lightweight, in-page spotlight tour (no external dependency). */
@Injectable({ providedIn: 'root' })
export class TourService {
  private readonly _steps = signal<TourStep[]>([]);
  private readonly _currentIndex = signal<number | null>(null);

  readonly steps = this._steps.asReadonly();
  readonly currentIndex = this._currentIndex.asReadonly();

  start(steps: TourStep[]): void {
    if (steps.length === 0) {
      return;
    }
    this._steps.set(steps);
    this._currentIndex.set(0);
  }

  next(): void {
    const index = this._currentIndex();
    if (index === null) {
      return;
    }
    if (index + 1 >= this._steps().length) {
      this.finish();
      return;
    }
    this._currentIndex.set(index + 1);
  }

  prev(): void {
    const index = this._currentIndex();
    if (index === null || index === 0) {
      return;
    }
    this._currentIndex.set(index - 1);
  }

  finish(): void {
    this._currentIndex.set(null);
    this._steps.set([]);
  }
}
